<div class="p-6 bg-gray-50 min-h-screen">
  <!-- Header Section -->
  <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-8">
    <div>
      <h1 class="text-3xl font-bold bg-gradient-to-r from-gray-800 to-gray-600 bg-clip-text text-transparent">Role Access Management</h1>
      <p class="text-sm text-gray-500 mt-1">Configure permissions and access controls for different roles</p>
    </div>

    <div class="flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
      <div class="flex flex-col gap-1">
        <!-- <label class="text-xs font-semibold text-gray-600 uppercase tracking-wide">Select Role</label> -->
        <p-dropdown 
          [options]="roles"
          [(ngModel)]="selectedRole"
          optionLabel="name"
          placeholder="Choose a role..."
          [filter]="true"
          filterBy="name"
          [filterPlaceholder]="'Search role...'"
          [showClear]="true"
          appendTo="body"
          [baseZIndex]="10000"
          styleClass="w-64 rounded border border-gray-300 shadow-sm focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition duration-150 text-gray-700 bg-white"
         
          (onChange)="getRoleMapping()"
        >
          
        </p-dropdown>
      </div>
      
      <button 
        type="button"
        class="inline-flex items-center gap-1 px-3 py-1.5 rounded bg-blue-600 hover:bg-blue-700 text-white text-xs font-medium transition mt-2 sm:mt-0 h-8"
        (click)="openAddMenuDialog(false)"
        *ngIf="selectedRole != null && '/setup' | hasPermission: 'Add'">
        <i class="pi pi-plus text-xs"></i>
        Add Menu
      </button>
      <button 
        type="button"
        class="inline-flex items-center gap-1 px-3 py-1.5 rounded bg-green-600 hover:bg-green-700 text-white text-xs font-medium transition ml-2 h-8"
        [disabled]="selectedRole == null" 
        (click)="saveChanges()" 
        *ngIf="selectedRole != null && '/setup' | hasPermission: 'Add'">
        <i class="pi pi-save text-xs"></i>
        Save
      </button>
    </div>
  </div>

  <!-- Save Changes Button -->
 

  <!-- Table Section -->
  <div class="bg-white rounded-xl shadow-lg border border-gray-100 overflow-hidden" *ngIf="selectedRole != null">
    <div class="overflow-x-auto">
      <p-table [value]="flatModules" [tableStyle]="{ 'min-width': '600px' }" class="w-full">
        <ng-template pTemplate="header">
          <tr class="bg-gradient-to-r from-gray-50 to-gray-100 border-b border-gray-200">
            <th class="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Module</th>
            <th *ngFor="let perm of permissions" class="px-6 py-4 text-center text-xs font-semibold text-gray-600 uppercase tracking-wider">
              {{ perm.name }}
            </th>
            <th class="px-6 py-4 text-center text-xs font-semibold text-gray-600 uppercase tracking-wider">Enabled</th>
            <th class="px-6 py-4 text-center text-xs font-semibold text-gray-600 uppercase tracking-wider" *ngIf="canEditSetup">Actions</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-module>
          <ng-container *ngTemplateOutlet="recursiveRow; context: { $implicit: module, level: 0 }"></ng-container>
        </ng-template>

        <ng-template #recursiveRow let-module let-level="level">
          <tr class="border-b border-gray-100 hover:bg-gray-50 transition-colors duration-150">
            <td class="px-6 py-4">
              <div class="flex items-center justify-between w-full  px-2 py-1 rounded-md text-sm font-medium  text-white border border-blue-200 shadow-sm" 
              [ngClass]="{
                'bg-indigo-500 text-indigo-700 border-indigo-200': level == 0,
                'bg-emerald-500 text-emerald-700 border-emerald-200': level == 1,
                'bg-amber-500 text-amber-700 border-amber-200': level == 2,
                'bg-rose-500 text-rose-700 border-rose-200': level == 3
              }">  
                <span >
                   {{ module.name }}
                </span>
            
                <i 
                  *ngIf="module.children && module.children.length > 0" 
                  [ngClass]="{
                    'pi-chevron-up': expandedMenus.has(module.id),
                    'pi-chevron-down': !expandedMenus.has(module.id)
                  }" 
                  (click)="toggleExpand(module.id)" 
                  class="pi cursor-pointer text-gray-400 hover:text-gray-600 text-sm transition-colors ml-auto">
                </i>
            
              </div>
            </td>
            
            <td *ngFor="let perm of permissions" class="px-6 py-4 text-center">
              <p-checkbox 
                [(ngModel)]="module.permissions[perm.name]" 
                binary="true"
                (onChange)="onPermissionChange(module)">
              </p-checkbox>
            </td>
            
            <td class="px-6 py-4 text-center">
              <p-inputSwitch 
                [(ngModel)]="module.enabled"
                (onChange)="onToggleChange(module)">
              </p-inputSwitch>
            </td>
            
            <td class="px-6 py-4 text-center" *ngIf="canEditSetup">
              <div class="flex items-center justify-center gap-2">
                <button
                  pTooltip="Add Sub Menu"
                  (click)="openAddMenuDialog(true, module)"
                  *ngIf="'/setup' | hasPermission: 'Add'"
                  class="w-8 h-8 flex items-center justify-center rounded-lg bg-purple-50 text-purple-600 border border-purple-200 hover:bg-purple-100 hover:border-purple-300 transition-all duration-200">
                  <i class="pi pi-plus text-xs"></i>
                </button>

                <button
                  pTooltip="Edit Menu"
                  (click)="editMenu(module, !!module.parent)"
                  *ngIf="'/setup' | hasPermission: 'Edit'"
                  class="w-8 h-8 flex items-center justify-center rounded-lg bg-amber-50 text-amber-600 border border-amber-200 hover:bg-amber-100 hover:border-amber-300 transition-all duration-200">
                  <i class="pi pi-pencil text-xs"></i>
                </button>

                <button
                  pTooltip="Delete Menu"
                  (click)="deleteMenu(module)"
                  *ngIf="'/setup' | hasPermission: 'Delete'"
                  class="w-8 h-8 flex items-center justify-center rounded-lg bg-red-50 text-red-600 border border-red-200 hover:bg-red-100 hover:border-red-300 transition-all duration-200">
                  <i class="pi pi-trash text-xs"></i>
                </button>
              </div>
            </td>
          </tr>
          
          <ng-container *ngIf="expandedMenus.has(module.id)">
            <ng-container *ngFor="let child of module.children">
              <ng-container *ngTemplateOutlet="recursiveRow; context: { $implicit: child, level: level + 1 }"></ng-container>
            </ng-container>
          </ng-container>
        </ng-template>
      </p-table>
    </div>
  </div>

  <!-- Empty State -->
  <div class="flex flex-col items-center justify-center h-96 bg-white rounded-xl shadow-sm border-2 border-dashed border-gray-200" *ngIf="selectedRole == null">
    <i class="pi pi-lock text-5xl text-gray-300 mb-4"></i>
    <h5 class="text-lg text-gray-500 font-medium">Select a role to view privileges</h5>
    <p class="text-sm text-gray-400 mt-1">Choose a role from the dropdown above to manage access permissions</p>
  </div>
</div>

<!-- Add Menu Dialog -->
<p-dialog 
  [header]="getDialogHeader()" 
  [(visible)]="showMenuDialog" 
  [modal]="true" 
  [style]="{ width: '450px' }"
  [closable]="true" 
  [maximizable]="true"
  [baseZIndex]="10000">
  <form [formGroup]="menuForm" (ngSubmit)="saveMenu()">
    <div class="flex flex-col gap-5 py-2">
      <div class="flex flex-col gap-2">
        <label for="menuName" class="text-sm font-semibold text-gray-700">Menu Name <span class="text-red-500">*</span></label>
        <input 
          id="menuName" 
          type="text" 
          pInputText 
          formControlName="name" 
          placeholder="Enter menu name"
          class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200" />
        <small *ngIf="menuForm.controls['name'].invalid && menuForm.controls['name'].touched" class="text-red-500 text-xs">
          Menu Name is required.
        </small>
      </div>

      <div class="flex flex-col gap-2">
        <label for="menuUrl" class="text-sm font-semibold text-gray-700">URL</label>
        <input 
          id="menuUrl" 
          type="text" 
          pInputText 
          formControlName="url" 
          placeholder="/path/to/page"
          class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200" />
      </div>

      <div class="flex flex-col gap-2">
        <label for="menuIcon" class="text-sm font-semibold text-gray-700">Icon</label>
        <input 
          id="menuIcon" 
          type="text" 
          pInputText 
          formControlName="icon" 
          placeholder="MessageSquare"
          class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200" />
        <p class="text-xs text-gray-500 mt-1">Use PrimeIcons or custom icon names</p>
      </div>

      <div class="flex flex-col gap-2" *ngIf="showParentDropdown">
        <label for="menuParent" class="text-sm font-semibold text-gray-700">Parent Menu</label>
        <p-dropdown 
          id="menuParent" 
          [options]="parentMenuOptions" 
          formControlName="parent" 
          optionLabel="name"
          optionValue="id" 
          placeholder="Select parent (optional)" 
          [filter]="true" 
          filterBy="name"
          styleClass="w-full">
        </p-dropdown>
      </div>

      <div class="flex items-center gap-3" *ngIf="!isSubMenu">
        <p-checkbox 
          inputId="isSchemeMenu" 
          formControlName="isSchemeMenu" 
          binary="true">
        </p-checkbox>
        <label for="isSchemeMenu" class="text-sm text-gray-700 cursor-pointer">Is scheme menu?</label>
      </div>

      <div class="flex flex-col gap-2" *ngIf="menuForm.get('isSchemeMenu')?.value">
        <label for="schemeId" class="text-sm font-semibold text-gray-700">Select Scheme</label>
        <p-dropdown 
          inputId="scheme" 
          formControlName="scheme" 
          [options]="schemes" 
          [filter]="true" 
          filterBy="name"
          optionLabel="name" 
          placeholder="Select Scheme" 
          optionValue="id"
          styleClass="w-full">
        </p-dropdown>
      </div>

      <div class="flex justify-end gap-3 mt-2 pt-3 border-t border-gray-100">
        <button 
          type="button"
          pButton 
          label="Cancel" 
          icon="pi pi-times"
          class="bg-gray-100 hover:bg-gray-200 text-gray-700 border-none rounded-lg px-4 py-2 text-sm font-medium transition-all duration-200"
          (click)="showMenuDialog = false">
        </button>
        <button 
          pButton 
          type="submit" 
          label="Save Menu" 
          icon="pi pi-check"
          [disabled]="menuForm.invalid" 
          class="bg-blue-600 hover:bg-blue-700 text-white border-none rounded-lg px-4 py-2 text-sm font-medium transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed">
        </button>
      </div>
    </div>
  </form>
</p-dialog>

<!-- Edit Menu Dialog -->
<p-dialog 
  [header]="getDialogHeader()" 
  [(visible)]="showEditMenuDialog" 
  [modal]="true" 
  [style]="{ width: '450px' }"
  [closable]="true" 
  [maximizable]="true"
  [baseZIndex]="10000">
  <form [formGroup]="menuForm" (ngSubmit)="saveEditMenu()">
    <div class="flex flex-col gap-5 py-2">
      <div class="flex flex-col gap-2">
        <label for="menuName" class="text-sm font-semibold text-gray-700">Menu Name <span class="text-red-500">*</span></label>
        <input 
          id="menuName" 
          type="text" 
          pInputText 
          formControlName="name" 
          placeholder="Enter menu name"
          class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200" />
        <small *ngIf="menuForm.controls['name'].invalid && menuForm.controls['name'].touched" class="text-red-500 text-xs">
          Menu Name is required.
        </small>
      </div>

      <div class="flex flex-col gap-2">
        <label for="menuUrl" class="text-sm font-semibold text-gray-700">URL</label>
        <input 
          id="menuUrl" 
          type="text" 
          pInputText 
          formControlName="url" 
          placeholder="/path/to/page"
          class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200" />
      </div>

      <div class="flex flex-col gap-2">
        <label for="menuIcon" class="text-sm font-semibold text-gray-700">Icon</label>
        <input 
          id="menuIcon" 
          type="text" 
          pInputText 
          formControlName="icon" 
          placeholder="MessageSquare"
          class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200" />
      </div>

      <div class="flex flex-col gap-2">
        <label for="menuParent" class="text-sm font-semibold text-gray-700">Parent Menu</label>
        <p-dropdown 
          id="menuParent" 
          [options]="parentMenuOptions" 
          formControlName="parent" 
          optionLabel="name"
          optionValue="id" 
          placeholder="Select parent (optional)" 
          [filter]="true" 
          filterBy="name"
          styleClass="w-full">
        </p-dropdown>
      </div>

      <div class="flex items-center gap-3" *ngIf="!isSubMenu">
        <p-checkbox 
          inputId="isSchemeMenu" 
          formControlName="isSchemeMenu" 
          binary="true">
        </p-checkbox>
        <label for="isSchemeMenu" class="text-sm text-gray-700 cursor-pointer">Is scheme menu?</label>
      </div>

      <div class="flex flex-col gap-2" *ngIf="menuForm.get('isSchemeMenu')?.value">
        <label for="schemeId" class="text-sm font-semibold text-gray-700">Select Scheme</label>
        <p-dropdown 
          inputId="scheme" 
          formControlName="scheme" 
          [options]="schemes" 
          [filter]="true" 
          filterBy="name"
          optionLabel="name" 
          placeholder="Select Scheme" 
          optionValue="id"
          styleClass="w-full">
        </p-dropdown>
      </div>

      <div class="flex justify-end gap-3 mt-2 pt-3 border-t border-gray-100">
        <button 
          type="button"
          pButton 
          label="Cancel" 
          icon="pi pi-times"
          class="bg-gray-100 hover:bg-gray-200 text-gray-700 border-none rounded-lg px-4 py-2 text-sm font-medium transition-all duration-200"
          (click)="showEditMenuDialog = false">
        </button>
        <button 
          pButton 
          type="submit" 
          label="Update Menu" 
          icon="pi pi-save"
          [disabled]="menuForm.invalid" 
          class="bg-blue-600 hover:bg-blue-700 text-white border-none rounded-lg px-4 py-2 text-sm font-medium transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed">
        </button>
      </div>
    </div>
  </form>
</p-dialog>

<!-- Delete Dialog -->
<p-dialog 
  header="Delete Menu" 
  [modal]="true" 
  [(visible)]="showDeleteDialog" 
  [style]="{ width: '28rem' }"
  [maximizable]="true"
  [baseZIndex]="10000">
  <div class="flex flex-col items-center gap-6 py-6">
    <div class="w-16 h-16 rounded-full bg-red-100 flex items-center justify-center">
      <i class="pi pi-exclamation-triangle text-3xl text-red-500"></i>
    </div>
    <div class="text-center">
      <h3 class="text-lg font-semibold text-gray-800 mb-2">Confirm Deletion</h3>
      <span class="text-gray-600">Are you sure you want to delete this menu? This action cannot be undone.</span>
    </div>
    <div class="flex gap-3">
      <button 
        pButton 
        label="Cancel" 
        icon="pi pi-times"
        class="bg-gray-100 hover:bg-gray-200 text-gray-700 border-none rounded-lg px-5 py-2 text-sm font-medium transition-all duration-200"
        (click)="showDeleteDialog = false">
      </button>
      <button 
        pButton 
        label="Delete" 
        icon="pi pi-trash" 
        class="bg-red-600 hover:bg-red-700 text-white border-none rounded-lg px-5 py-2 text-sm font-medium transition-all duration-200"
        (click)="confirmDelete()">
      </button>
    </div>
  </div>
</p-dialog>